import { Skeleton } from '@/shared/components/Skeleton';
import { ProductCardSkeleton } from './ProductCardSkeleton';
import { cn } from '@/shared/utils/cn';

const FILTER_PILLS = 6;
// Always render enough cards for 3 columns × 4 rows.
// CSS grid collapses to 2 columns on mobile without JS.
const PRODUCT_SKELETON_CARDS = 12;

export interface PlpSkeletonProps {
  showFilterPills?: boolean;
}

export function PlpSkeleton({ showFilterPills = true }: PlpSkeletonProps) {
  return (
    <div className="space-y-4" aria-label="Loading">
      {showFilterPills ? (
        /* Keep pills in a single horizontal row — mobile only (desktop has sidebar) */
        <div className="flex flex-nowrap gap-2 overflow-hidden md:hidden">
          {Array.from({ length: FILTER_PILLS }).map((_, i) => (
            <Skeleton key={i} className="h-9 w-20 shrink-0 rounded-full" />
          ))}
        </div>
      ) : null}
      {/* Product grid — CSS-only responsive to avoid SSR/hydration mismatch */}
      <div className={cn('grid gap-3 grid-cols-2 md:grid-cols-3')}>
        {Array.from({ length: PRODUCT_SKELETON_CARDS }).map((_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}
